// MB向けのサービス名
const MemberTechCompanyName = () => {
  return 'クラウドワークス テック'
}

export default MemberTechCompanyName
